import { useState } from "react";
export default function () {
  const [media, setMedia] = useState("");
  var extraSmall = window.matchMedia("(max-width:500px)");
  var small = window.matchMedia("(min-width:550px)");
  var medium = window.matchMedia("(min-width:700px)");
  var lg = window.matchMedia("(min-width:900px)");
  var extraLarge = window.matchMedia("(min-width:1200px)");
  function handleChange() {
    if (extraLarge.matches) {
      setMedia("desktop");
    } else if (lg.matches) {
      setMedia("laptop");
    } else if (medium.matches) {
      setMedia("tablet");
    } else if (small.matches) {
      setMedia("mobile");
    } else if (extraSmall.matches) {
      setMedia("smallMobile");
    }
  }
  if (media === "") {
    handleChange();
  }
  window.addEventListener("resize", () => {
    handleChange();
  });
  return media;
}
